import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFacebook = function SvgFacebook(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#0866FF",
        d: "M120 60c0-33.137-26.863-60-60-60S0 26.863 0 60c0 28.139 19.372 51.749 45.505 58.233V78.335H33.133V60h12.372v-7.9c0-20.423 9.242-29.888 29.292-29.888 3.801 0 10.36.745 13.043 1.49v16.621c-1.416-.149-3.876-.223-6.931-.223-9.839 0-13.64 3.726-13.64 13.416V60h19.598L83.5 78.335H67.27v41.226C96.978 115.972 120 90.676 120 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M83.5 78.335 86.867 60H67.27v-6.484c0-9.69 3.801-13.416 13.64-13.416 3.055 0 5.515.074 6.931.223v-16.62c-2.683-.746-9.242-1.491-13.043-1.491-20.05 0-29.292 9.465-29.292 29.888V60H33.133v18.335h12.372v39.898A60 60 0 0 0 60 120c2.46 0 4.886-.152 7.269-.439V78.335z"
    })));
};

export { SvgFacebook as ReactComponent };
//# sourceMappingURL=Facebook.svg.es.js.map
